import { Box, Typography } from '@mui/material';
import sanitizeHtml from 'sanitize-html';
import he from 'he';
import { useSearchDirectoryData } from '@/context/searchDirectory/SearchDirectoryDataContext';
import { useResponsive } from '@/components/hooks/useResponsive';
import { ZipCodeConversion } from '@/components/feature/searchDirectory/ZipCodeConversion';
import { trackAmplitudeEvent } from '@/lib/analyticsHelper';

export const HeroConversionBox = () => {
  const pageData = useSearchDirectoryData();
  const { isLargeViewport } = useResponsive();
  const { headline, subHeadline } = pageData.seoSegmentationDetails;
  const ctaText = 'Get started';
  const handleCtaBtn = () => {
    const amplitudeData = {
      cta_text: ctaText,
      cta_type: 'button',
    };

    trackAmplitudeEvent('CTA Interacted', amplitudeData);
  };

  return (
    <Box
      sx={{
        mb: 4,
      }}>
      <Typography
        component="h1"
        variant={isLargeViewport ? 'display1' : 'display2'}
        color="primary"
        sx={{
          mb: { xs: 2, sm: 3 },
          mt: 0,
        }}
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(he.decode(headline)),
        }}
      />
      <Typography
        component="p"
        variant="body2"
        mb={4}
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(he.decode(subHeadline.replace(/<\/?p>/g, ''))),
        }}
      />
      <ZipCodeConversion showZipCodeInputField handleCtaBtn={handleCtaBtn} ctaText={ctaText} />
    </Box>
  );
};
